import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TopNavBarComponent } from './top-nav-bar/top-nav-bar.component';
import { TopNavButtonComponent } from './top-nav-button/top-nav-button.component';

@NgModule({
  declarations: [
    TopNavBarComponent,
    TopNavButtonComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    TopNavBarComponent,
  ]
})
export class TopNavModule { }
